import { requst } from '../config'

// 项目开始结束日期
export const getProjectStartEndDateApi = projectId => {
    const url = `/setting/project/${projectId}`
    return requst.get(url)
}

// 节点布设 数据集明细
export const postReceiverDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 接收 statistic 折线图
export const postReceiverLineDataApi = params => {
    const url = `/report/dashboard/dashboardReceiverTotal`
    return requst.post(url, params)
}

// 接收 环形图
export const postReceiverAnnularDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 节点布设 船列表
export const getReceiverLocationListApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}&type=2`
    return requst.get(url)
}

// 炮点 数据集明细
export const postAcquisitionDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 油水 折线图
export const postConsumableLineDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 炮点 statistic 折线图
export const postAcquisitionLineDataApi = params => {
    const url = `/report/dashboard/dashboardSourceForecast`
    return requst.post(url, params)
}

// 炮点 statistic 折线图 临时方案
export const postAcquisitionLinePanDataApi = params => {
    const url = `/setting/productionPlan/listPlanByDate?projectId=${params.projectId}&endDate=${params.endDate}&startDate=${params.startDate}`
    return requst.get(url, params)
}

// 炮点 TZ statistic 折线图
export const postAcquisitionLineTZDataApi = params => {
    const url = `/quake/source/dashboardTZTotal?projectId=${params.projectId}&endDate=${params.endDate}&startDate=${params.startDate}`
    return requst.get(url)
}

// 营收 炮点按天统计
export const postProfitIncomeDayDataApi = params => {
    const url = `/business/dashboard/sourceDay`
    return requst.post(url, params)
}

// 营收 节点按天统计
export const postProfitIncomeDeploymentDayDataApi = params => {
    const url = `/business/dashboard/nodeDay`
    return requst.post(url, params)
}

// 营收 standBy按天统计
export const postProfitIncomeStandByDayDataApi = params => {
    const url = `/business/dashboard/standbyDay`
    return requst.post(url, params)
}

// 营收 周月年统计
export const postProfitIncomeStageDataApi = params => {
    const url = `/business/dashboard/stage`
    return requst.post(url, params)
}

// 营收 第三方数据
export const postProfitIncomeThirdDataApi = params => {
    const url = `/business/dashboard/third`
    return requst.post(url, params)
}

// 营收 炮点 第三方数据 类型
export const postCompensationThirdDataApi = params => {
    const url = `/business/dashboard/compensation`
    return requst.post(url, params)
}

// 营收 炮点 第三方数据 日期
export const postCompensationThirdDateDataApi = params => {
    const url = `business/dashboard/compensationDate`
    return requst.post(url, params)
}

// 营收 导入
export const postProfitIncomeImportDataApi = projectId => {
    const url = `/business/compensation/init/${projectId}`
    return requst.get(url)
}

// 营收 折线图
export const postProfitIncomeLineDataApi = params => {
    const url = `/business/dashboard/accumulative`
    return requst.post(url, params)
}

// 营收 折线图 放炮+节点+standby+其他 按日
export const getIncomeDailyApi = params => {
    const url = `/business/dashboard/summaryDay`
    return requst.post(url, params)
}

// 营收 折线图 放炮+节点+standby+其他 按月
export const getIncomeMonthApi = params => {
    const url = `/business/dashboard/summaryMonth`
    return requst.post(url, params)
}

// 营收 总金额
export const postTotalMoneyDataApi = params => {
    const url = `/business/dashboard/total`
    return requst.post(url, params)
}

// 拖缆 statistic 折线图
// export const postAcquisitionStreamerLineDataApi = params => {
//     const url = `/report/dashboard/dashboardStreamerTotal`
//     return requst.post(url, params)
// }
export const postAcquisitionStreamerLineDataApi = (params) => {
    const url = `/monitor/acquisition/streamer/dashboardStreamerTotal?projectId=${params?.projectId}&endDate=${params?.endDate}&startDate=${params?.startDate}`
    return requst.get(url)
}

// 施工进度 环形图
export const postAcquisitionAnnularDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 炮点 船列表
export const getAcquisitionLocationListApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}&type=1`
    return requst.get(url)
}

// 炮点激发 船列表
export const getAcquisitionStreamerLocationListApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}&type=5`
    return requst.get(url)
}

// 施工进度 面积
export const postProspectDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 时效 船列表
export const getTimingLocationListApi = projectId => {
    const url = `/setting/location/list?projectId=${projectId}`
    return requst.get(url)
}

// 时效 数据集明细
export const postTimingEchartsApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 时效 自定义数据，柱状图
// export const getCustomTimingBarEchartsApi = params => {
//     let url = ''
//     if (params?.locationId) {
//         url = `/monitor/activity/diary/dashboard/timing?startDate=${params.startDate}&endDate=${params.endDate}&projectId=${params.projectId}&locationId=${params.locationId}`
//     } else {
//         url = `/monitor/activity/diary/dashboard/timing?startDate=${params.startDate}&endDate=${params.endDate}&projectId=${params.projectId}`
//     }
//     return requst.get(url)
// }
export const getCustomTimingBarEchartsApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 时效 自定义数据，饼图
// export const getCustomTimingPieEchartsApi = params => {
//     let url = ''
//     if (params?.locationId) {
//         url = `/monitor/activity/diary/dashboard/customTimingPie?startDate=${params.startDate}&endDate=${params.endDate}&projectId=${params.projectId}&locationId=${params.locationId}`
//     } else {
//         url = `/monitor/activity/diary/dashboard/customTimingPie?startDate=${params.startDate}&endDate=${params.endDate}&projectId=${params.projectId}`
//     }
//     return requst.get(url)
// }
export const getCustomTimingPieEchartsApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// HSE 数据集明细
export const postHSEDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// HSE table
export const getHSETableApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// HSE 进度
export const getHSEToroidalApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// HSE 折线图
export const  getHSEPieDataApi = params => {
    const url = `/report/dashboard/getSet`
    return requst.post(url, params)
}

// 保存地图经纬度和zoom
export const postMapDataApi = params => {
    const url = `/userMapConfig/save`
    return requst.post(url, params)
}

// 获取地图经纬度和zoom
export const getMapDataApi = (mapType) => {
    const url = `/userMapConfig/get?mapType=${mapType}`
    return requst.get(url)
}